import angular from 'angular';
import _ from 'lodash';
import moment from 'moment';

(function () {
    'use strict';
    angular.module('app.core').factory('LegalEntity', LegalEntityData);

    LegalEntityData.$inject = ['$translate', 'logger', 'Container', 'CompanyPlatform'];

    /* @ngInject */
    function LegalEntityData($translate, logger, Container, CompanyPlatform) {
        LegalEntity.prototype = {
            build,
            buildEmpty,
            getNameForList,
            getFiscalKindLabel,
            getNationalKindLabel,
            getIdentifiant,
            getCountryLabel,
            getLangLabel,
            createOrUpdateDefaultContact,
        };

        function LegalEntity(legalEntityData) {
            if (!legalEntityData) {
                this.buildEmpty();
            } else {
                this.build(legalEntityData);
            }
        }

        return LegalEntity;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.countryCode = null;
            this.language = null;
            this.name = null;
            this.alias = null;
            this.address1 = null;
            this.address2 = null;
            this.zipCode = null;
            this.city = null;
            this.state = null;
            this.idFiscal = null;
            this.idFiscalKind = null;
            this.idNational = null;
            this.idNationalKind = null;
            this.idElectronic = null;
            this.groupId = null;
            this.group = null;
            this.transmissionModes = null;
            this.dematMode = null;
            this.dematModesAllowed = null;
            this.perimeters = null;
            this.dematGisId = null;
            this.dematPasrelId = null;
            this.contactEmail = null;
            this.contactFirstname = null;
            this.contactLastname = null;
            this.contactPhone = null;
            this.legalEntityContacts = [];
            this.dematPlatform = null;
            this.containers = null;
            this.epdfEnable = null;
            this.platformPath = null;
            this.ePlatformPath = null;
            this.hasDocumentarySpace = null;
            this.documentarySpaceId = null;
            this.apeCode = null;
            this.legalContactFirstname = null;
            this.legalContactLastname = null;
            this.paymentEnabled = null;
            this.sspRef = null;
            this.invoiceRecieverEmail = null;
            this.hasOneStopShop = null;
            this.facturXEnabled = null;
            this.ptInvoiceCertification = null;
            this.ptReportingSaft = null;
            this.mandateSii = {
                enabled: false,
                zone: null,
            };
            this.pdpRe = {
                startDate: null,
                endDate: null,
                sentToPpf: false,
                transmissionId: null,
                ppfStatus: null,
                migrationCode: null,
                complianceStatus: null,
            };
            this.pdpEm = {
                startDate: null,
                endDate: null,
                migrationCode: null,
                complianceStatus: null,
            };
            this.peppolIdentifiers = [];
            this.ereporting = {
                sellerSetting: {
                    transactionComplete: null,
                    paymentComplete: null,
                    startDate: null,
                    endDate: null,
                },
                buyerSetting: {
                    transactionComplete: null,
                    startDate: null,
                    endDate: null,
                },
            };
            this.legalEntityPlatform = [];
            this.offresApi = [];
        }

        function build(legalEntityData) {
            buildGeneralInfos(this, legalEntityData);
            buildAddress(this, legalEntityData);
            buildIds(this, legalEntityData);
            buildGroup(this, legalEntityData);
            buildTransmissionModes(this, legalEntityData);
            this.creationDate = legalEntityData.creationDate || null;
            buildPerimeters(this, legalEntityData);
            buildDematPlatform(this, legalEntityData);
            this.legalEntityContacts = legalEntityData.legalEntityContacts || [];
            this.offresApi = legalEntityData.offresApi || [];
            this.facturXEnabled = legalEntityData.facturXEnabled || null;
            buildMandateSii(this, legalEntityData);
            buildDefaultContact(this);
            this.containers =
                _.map(legalEntityData.containers, function (container) {
                    return new Container(container);
                }) || null;
            this.epdfEnable = legalEntityData.epdfEnable || null;
            this.platformPath = legalEntityData.platformPath || null;
            this.ePlatformPath = legalEntityData.ePlatformPath || null;
            buildDocumentarySpace(this, legalEntityData);
            this.apeCode = legalEntityData.apeCode || null;
            buildLegalContact(this, legalEntityData);
            buildSspRef(this, legalEntityData);
            this.invoiceRecieverEmail = legalEntityData.invoiceRecieverEmail || null;
            this.ptInvoiceCertification = legalEntityData.ptInvoiceCertification || null;
            this.ptReportingSaft = legalEntityData.ptReportingSaft || null;
            buildPdpRe(this, legalEntityData);
            buildPdpEm(this, legalEntityData);
            buildEreportingAndVatRegime(this, legalEntityData);
            buildOnStopShop(this, legalEntityData);
            buildpeppolIdentifiers(this, legalEntityData);
        }

        function buildGeneralInfos(currentObj, legalEntityData) {
            currentObj.id = legalEntityData.id || null;
            currentObj.countryCode = legalEntityData.countryCode || null;
            currentObj.language = legalEntityData.language || null;
            currentObj.name = legalEntityData.name || null;
            currentObj.alias = legalEntityData.alias || null;
        }

        function buildMandateSii(currentObj, legalEntityData) {
            if (legalEntityData.mandateSii != null) {
                currentObj.mandateSii = {
                    enabled: legalEntityData.mandateSii.enabled || false,
                    zone: legalEntityData.mandateSii.zone || null,
                };
            }
        }

        function buildPerimeters(currentObj, legalEntityData) {
            currentObj.perimeters = legalEntityData.perimeters || null;
        }

        function buildGroup(currentObj, legalEntityData) {
            currentObj.groupId = legalEntityData.groupId || null;
            currentObj.group = legalEntityData.group || null;
        }

        function buildTransmissionModes(currentObj, legalEntityData) {
            currentObj.transmissionModes = angular.lowercase(legalEntityData.transmissionModes);
            currentObj.dematMode = legalEntityData.dematMode || null;
            currentObj.dematModesAllowed = angular.lowercase(legalEntityData.dematModesAllowed);
        }

        function buildDematPlatform(currentObj, legalEntityData) {
            currentObj.dematGisId = legalEntityData.dematGisId || null;
            currentObj.dematPasrelId = legalEntityData.dematPasrelId || null;
            currentObj.dematPlatform = legalEntityData.dematPlatform || null;
            currentObj.legalEntityPlatform = transformPlateforms(legalEntityData.legalEntityPlatform);
        }

        function buildOnStopShop(currentObj, legalEntityData) {
            currentObj.hasOneStopShop = legalEntityData.hasOneStopShop || false;
        }
        function transformPlateforms(platforms) {
            return platforms ? platforms.map(element => new CompanyPlatform(element)) : [];
        }

        function buildEreportingAndVatRegime(currentObj, legalEntityData) {
            currentObj.vatRegime = legalEntityData.vatRegime;
            if (legalEntityData.ereporting != null) {
                currentObj.ereporting = legalEntityData.ereporting;
                if (legalEntityData.ereporting.buyerSetting != null && legalEntityData.ereporting.buyerSetting.startDate != null) {
                    currentObj.ereporting.buyerSetting.startDate = legalEntityData.ereporting.buyerSetting.startDate
                        ? moment(legalEntityData.ereporting.buyerSetting.startDate).startOf('day')
                        : null
                    currentObj.ereporting.buyerSetting.endDate = legalEntityData.ereporting.buyerSetting.endDate
                        ? moment(legalEntityData.ereporting.buyerSetting.endDate).startOf('day')
                        : null
                }
                if (legalEntityData.ereporting.sellerSetting != null && legalEntityData.ereporting.sellerSetting.startDate != null) {
                    currentObj.ereporting.sellerSetting.startDate = legalEntityData.ereporting.sellerSetting.startDate
                        ? moment(legalEntityData.ereporting.sellerSetting.startDate).startOf('day')
                        : null
                    currentObj.ereporting.sellerSetting.endDate = legalEntityData.ereporting.sellerSetting.endDate
                        ? moment(legalEntityData.ereporting.sellerSetting.endDate).startOf('day')
                        : null
                }

            }
        }

        function buildPdpEm(currentObj, legalEntityData) {
            if (legalEntityData.pdpEm != null) {
                currentObj.pdpEm = {
                    startDate: legalEntityData.pdpEm.startDate ? moment(legalEntityData.pdpEm.startDate) : null,
                    endDate: legalEntityData.pdpEm.endDate ? moment(legalEntityData.pdpEm.endDate) : null,
                    migrationCode: legalEntityData.pdpEm.migrationCode,
                    complianceStatus: legalEntityData.pdpEm.complianceStatus,
                };
            }
        }

        function buildpeppolIdentifiers(currentObj, legalEntityData) {
            if (legalEntityData.peppolIdentifiers != null) {
                var peppolIdentifiers = _.map(legalEntityData.peppolIdentifiers, data => ({
                    startDate: data.startDate,
                    endDate: data.endDate,
                    isActive: data.isActive,
                    legIdentifierKind: data.legIdentifierKind,
                    migrationCode: data.migrationCode,
                    disabledData: data.isActive
                }));
                var temp = peppolIdentifiers
                var peppolNational = {}
                var peppolFiscal = {}
                for (var i = 0; i < temp.length; i++) {
                    if(angular.lowercase(legalEntityData.idNationalKind) == temp[i].legIdentifierKind){
                        peppolNational = temp[i];
                    }else if (angular.lowercase(legalEntityData.idFiscalKind) == temp[i].legIdentifierKind){
                        peppolFiscal = temp[i];
                    }
                }

                currentObj.peppolIdentifiers=[peppolFiscal,peppolNational]
            } else {
                currentObj.peppolIdentifiers = [];
            }
        }
        function buildPdpRe(currentObj, legalEntityData) {
            if (legalEntityData.pdpRe != null) {
                currentObj.pdpRe = {
                    startDate: legalEntityData.pdpRe.startDate
                        ? moment(legalEntityData.pdpRe.startDate).startOf('day')
                        : null,
                    endDate: legalEntityData.pdpRe.endDate
                        ? moment(legalEntityData.pdpRe.endDate).startOf('day')
                        : null,
                    sentToPpf: legalEntityData.pdpRe.sentToPpf || false,
                    transmissionId: legalEntityData.pdpRe.transmissionId,
                    ppfStatus: legalEntityData.pdpRe.ppfStatus,
                    migrationCode: legalEntityData.pdpRe.migrationCode,
                    complianceStatus: legalEntityData.pdpRe.complianceStatus,
                };
            }
        }
        function buildSspRef(currentObj, legalEntityData) {
            currentObj.paymentEnabled = legalEntityData.paymentEnabled || null;
            currentObj.sspRef = legalEntityData.sspRef || null;
        }

        function buildDocumentarySpace(currentObj, legalEntityData) {
            currentObj.hasDocumentarySpace = legalEntityData.hasDocumentarySpace || null;
            currentObj.documentarySpaceId = legalEntityData.documentarySpaceId || null;
        }

        function buildLegalContact(currentObj, legalEntityData) {
            currentObj.legalContactFirstname = legalEntityData.legalContactFirstname || null;
            currentObj.legalContactLastname = legalEntityData.legalContactLastname || null;
        }

        function buildIds(currentObj, legalEntityData) {
            currentObj.idFiscal = legalEntityData.idFiscal || null;
            currentObj.idFiscalKind = angular.lowercase(legalEntityData.idFiscalKind);
            currentObj.idNational = legalEntityData.idNational || null;
            currentObj.idNationalKind = angular.lowercase(legalEntityData.idNationalKind);
            currentObj.idElectronic = legalEntityData.idElectronic || null;
        }

        function buildAddress(currentObj, legalEntityData) {
            currentObj.address1 = legalEntityData.address1 || null;
            currentObj.address2 = legalEntityData.address2 || null;
            currentObj.zipCode = legalEntityData.zipCode || null;
            currentObj.city = legalEntityData.city || null;
            currentObj.state = legalEntityData.state || null;
        }

        function buildDefaultContact(currentObj) {
            // Pour l'affichage, il faut récupérer un des contacts de type Principal. S'il n'y en a pas, on affiche rien.
            const { id, email, firstname, lastname, phone } = currentObj.legalEntityContacts.find(
                ({ type }) => type === 'P'
            ) || { id: '', email: '', firstname: '', lastname: '', phone: '' };

            currentObj.contactId = id;
            currentObj.contactEmail = email;
            currentObj.contactFirstname = firstname;
            currentObj.contactLastname = lastname;
            currentObj.contactPhone = phone;
        }

        function updateContact(contact, current) {
            contact.firstname = current.contactFirstname;
            contact.lastname = current.contactLastname;
            contact.phone = current.contactPhone;
            contact.email = current.contactEmail;
            return contact;
        }

        function deleteContact(contact, current) {
            const index = current.legalEntityContacts.indexOf(contact);
            if (index > -1) {
                current.legalEntityContacts.splice(index, 1);
            }
            return current;
        }

        /**
         * Met à jour les interlocuteurs
         */
        function createOrUpdateDefaultContact(allBuyersPartners, allSellersPartners) {
            const hasAtLeastOneValue = [
                this.contactFirstname,
                this.contactLastname,
                this.contactPhone,
                this.contactEmail,
            ].some(x => x);
            if (this.contactId) {
                // if it's an update
                const contactFound = this.legalEntityContacts.find(({ id }) => id === this.contactId);
                if (hasAtLeastOneValue) {
                    updateContact(contactFound, this);
                } else {
                    deleteContact(contactFound, this);
                }
            } else {
                // otherwise, it's a contact creation
                if (hasAtLeastOneValue) {
                    this.legalEntityContacts.push(
                        updateContact(
                            {
                                type: 'P',
                                allBuyersPartners,
                                allSellersPartners,
                            },
                            this
                        )
                    );
                }
            }
        }

        /**
         * Retourne le nom du fournisseur pour l'affichage dans la liste : SellerName (Identifiant)
         */
        function getNameForList() {
            var name = this.name;
            if (this.idFiscal) {
                name += ' (' + this.idFiscal + ')';
            } else if (this.idNational) {
                name += ' (' + this.idNational + ')';
            }
            return name;
        }

        /**
         * Récupère le label du type d'identifiant fiscal
         */
        function getFiscalKindLabel() {
            if (this.idFiscalKind) {
                return $translate.instant('identifiant.type.' + angular.lowercase(this.idFiscalKind));
            }
            return '';
        }

        /**
         * Récupère le label du type d'identifiant national
         */
        function getNationalKindLabel() {
            if (this.idNationalKind) {
                return $translate.instant('identifiant.type.' + angular.lowercase(this.idNationalKind));
            }
            return '';
        }

        function getIdentifiant() {
            var id = '';
            if (this.idFiscal) {
                id = this.idFiscal;
            } else if (this.idNational) {
                id = this.idNational;
            }
            return id;
        }

        function getCountryLabel() {
            if (this.countryCode) {
                return $translate.instant('country.' + angular.lowercase(this.countryCode));
            }
            return '';
        }

        function getLangLabel() {
            return $translate.instant('lang.' + angular.lowercase(this.legalEntity.language));
        }
    }
})();
